import moment, { Moment } from 'moment';
import { CategoryInterface, MenuInterface, OpeningHoursInterface } from '../exports/Interfaces';
import WorkScheduleHelpers from '../helpers/WorkScheduleHelpers';

export default class CategoryResource {
  private readonly schedule: OpeningHoursInterface[];

  constructor(category: CategoryInterface, menu?: MenuInterface, workSchedule?: OpeningHoursInterface[]) {
    this.schedule = category?.schedule ?? menu?.schedule ?? workSchedule;
  }

  public isActive(orderTime: Moment | string | null): boolean {
    if (!this?.schedule) {
      return true;
    }

    return WorkScheduleHelpers.isOpen(this.schedule, moment(orderTime ?? undefined));
  }

  public isActiveToday(): boolean {
    if (!this?.schedule) {
      return true;
    }

    return WorkScheduleHelpers.getCurrentDaySchedule(this?.schedule).isNotEmpty();
  }
}
